module.exports = __webpack_public_path__ + "static/media/iconCert.26b7aebd.svg";